import { useEffect, useState } from "react";
import Table from "../Table/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const TrainerAccordo = ({ accordoQuadro, setActiveTab }) => {
  const [newestAccordo, setNewestAccordo] = useState(null);
  const [allAccordoQuadro, setAllaccordoQuadro] = useState([]);
  const [displayAll, setDisplayAll] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const formatDateOnly = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  useEffect(() => {
    if (!accordoQuadro || accordoQuadro.length === 0) {
      setNewestAccordo(null);
      setAllaccordoQuadro([]);
      setDisplayAll(false);
    } else if (accordoQuadro.length === 1) {
      setNewestAccordo(accordoQuadro[0]);
      setAllaccordoQuadro([]);
      setDisplayAll(false);
    } else {
      const sortedAccordi = [...accordoQuadro].sort(
        (a, b) => new Date(b.dataAccordo) - new Date(a.dataAccordo)
      );
      setNewestAccordo(sortedAccordi[0]);
      const otherAccordi = sortedAccordi.slice(1).map((a) => ({
        ...a,
        dataAccordo: formatDateOnly(a.dataAccordo),
        dataProssimoAggiornamento: formatDateOnly(a.dataProssimoAggiornamento),
      }));
      setAllaccordoQuadro(otherAccordi);
      setDisplayAll(false);
    }
  }, [accordoQuadro]);

  const columns = [
    { field: "dataAccordo", header: "Data Accordo" },
    { field: "tipologiaAccordo", header: "Tipo Accordo" },
    { field: "quotaDaSistema", header: "Quota Sistema" },
    { field: "livelloAccordo", header: "Livello" },
    { field: "quotaOraria", header: "Quota Oraria" },
    { field: "importoDefinito", header: "Importo" },
    { field: "dataProssimoAggiornamento", header: "Prossimo Agg." },
    { field: "autore", header: "Autore" },
  ];

  const handleRowClick = (accordo) => {
    navigate(`/accordo-quadro/${accordo.id}`, {
      state: { returnTo: `/docente/${id}`, activeTab: "accordi" },
    });
  };

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="trainer-accordo-quadro">
      <div className="trainer-esperienze-lavorative-title">Accordo Quadro</div>

      {newestAccordo ? (
        <div className="trainer-data-fields">
          <div className="trainer-data">
            {[
              {
                label: "Tipologia Accordo",
                value: newestAccordo.tipologiaAccordo,
              },
              { label: "Livello Accordo", value: newestAccordo.livelloAccordo },
              {
                label: "Quota Da Sistema",
                value: newestAccordo.quotaDaSistema,
              },
              { label: "Quota Oraria", value: newestAccordo.quotaOraria },
              {
                label: "Importo Definito",
                value: newestAccordo.importoDefinito,
              },
              {
                label: "Data Accordo",
                value: formatDateOnly(newestAccordo.dataAccordo),
              },
              {
                label: "Data Prossimo Aggiornamento",
                value: formatDateOnly(newestAccordo.dataProssimoAggiornamento),
              },
              { label: "Autore", value: newestAccordo.autore },
            ].map((field, idx) => (
              <div className="trainer-field-row" key={idx}>
                <div className="trainer-field-label">{field.label}</div>
                <div className="trainer-field-value">
                  <span className="trainer-span-value">{field.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="no-data">Nessun accordo quadro.</div>
      )}

      {/* Show button only if there are extra accordi */}
      {allAccordoQuadro.length > 0 && !displayAll && (
        <button onClick={() => setDisplayAll(true)} className="show-all-btn">
          Tutti gli Accordi Quadro
        </button>
      )}

      {/* Show table only when button clicked */}
      {displayAll && allAccordoQuadro.length > 0 && (
        <div className="table-section">
          <div className="table-content accordi-table">
            <Table
              columns={columns}
              data={allAccordoQuadro}
              onRowClick={handleRowClick}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainerAccordo;
